import { Reveal } from "./Reveal";

const STEPS = [
  {
    no: "01",
    title: "Download & Isi Template Excel",
    desc: "Unduh template resmi lalu isi data nama, tanggal lahir, no passport, dan no visa jamaah Anda.",
  },
  {
    no: "02",
    title: "Kirim File Data Visa",
    desc: "Upload melalui form di web ini atau kirim langsung via WhatsApp Admin 082393244452.",
  },
  {
    no: "03",
    title: "Kami Booking Jadwal Permit",
    desc: "Tim INDORAWDAH memproses pemesanan jadwal permit Rawdah resmi sesuai slot yang tersedia.",
  },
  {
    no: "04",
    title: "Permit Terbit & Siap Digunakan",
    desc: "Permit Rawdah diterbitkan lengkap dengan barcode resmi, siap dibawa jamaah memasuki Raudhah.",
  },
];

export const HowItWorks = () => (
  <section id="cara-kerja" className="relative py-20 lg:py-28 bg-[#0A0F1D] border-y border-white/8" data-testid="how-it-works-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-sky-400">Cara Kerja</p>
        <h2 className="mt-4 font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl text-white" data-testid="how-it-works-title">
          Dari Data Visa Menjadi Permit Rawdah
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-6 relative">
        <div className="hidden lg:block absolute top-7 left-[12%] right-[12%] border-t border-dashed border-white/15" aria-hidden="true" />
        {STEPS.map((s, i) => (
          <Reveal key={s.no} delay={i * 0.1}>
            <div className="relative" data-testid={`step-${s.no}`}>
              <p className="font-mono2 font-semibold text-5xl text-gradient-accent">{s.no}</p>
              <h3 className="mt-5 font-display font-semibold text-lg text-white">{s.title}</h3>
              <p className="mt-2 text-sm text-slate-400 leading-relaxed">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
